import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t, language } = useLanguage();
  const returnTo = localStorage.getItem('erotika_payment_return') || searchParams.get('return_to');

  return (
    <div className="min-h-screen bg-velvet-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center animate-slideUp">
        <div className="w-20 h-20 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="text-orange-400" size={40} />
        </div>
        <h1 className="font-heading text-3xl text-velvet_text-primary mb-4">
          {language === 'fr' ? 'Paiement annulé' : 'Payment cancelled'}
        </h1>
        <p className="text-velvet_text-secondary mb-8">
          {language === 'fr' 
            ? 'Votre paiement a été annulé. Aucun montant n\'a été débité.'
            : 'Your payment has been cancelled. No amount has been charged.'
          }
        </p>
        <Button
          onClick={() => {
            localStorage.removeItem('erotika_payment_return');
            navigate(returnTo || '/select-gender');
          }}
          className="bg-purple-main hover:bg-purple-dark text-white rounded-full px-8 py-6"
          data-testid="back-button"
        >
          {language === 'fr' ? 'Retour' : 'Back'}
        </Button>
      </div>
    </div>
  );
}
